<div class="users-pill">
  <div
    class="user-option"
    *ngFor="let student of students"
    [class.active]="selectedStudent?.idStudent === student.idStudent"
    (click)="selectStudent(student)"
  >
    <img
      [src]="
        student.photo
          ? 'data:image/jpeg;base64,' + student.photo
          : 'assets/icons/3755622-etudiant-garcon-avec-ecole-table-dessin-anime-gratuit-vectoriel.jpg'
      "
      [alt]="student.nameStudent"
      class="avatar"
    />
    <span class="name">{{ student.nameStudent }}</span>
  </div>
</div>
